import React, { useEffect } from "react";

import { useAnalyticsTracker } from "components/instrumentation/source/analytics";
import { useAppContext } from "components/store/source";
import { Modal } from "components/ui/source";
import { LoadingLayout } from "components/ui/source/layouts";

import { useNavbarRendered } from "../Navbar/Navbar";

import { FourFactorAuthenticationForm } from "./FourFactorAuthenticationForm";
import LoginOptionsForm, { LoginOptionsHelpCenter } from "./LoginOptionsForm";

import styles from "./Accounts.module.scss";

function LoginOptionsPopup() {
  const {
    loginOptionsPopupIsOpen,
    loginOptionsPopupProps,
    closeLoginOptionsPopup,
  } = useAppContext();
  const isNavbarRendered = useNavbarRendered();
  const ModalClose = Modal["Close"];

  const modalProps = {
    isOpen: loginOptionsPopupIsOpen,
    onRequestClose: closeLoginOptionsPopup,
    shouldCloseOnOverlayClick: true,
    shouldCloseOnEsc: true,
    className: styles.modal,
    aria: {
      labelledby: "loginOptionsFormHeading",
    },
  };

  return isNavbarRendered ? (
    <Modal modalProps={modalProps}>
      <LogInOptionsPopupEvent
        loginOptionsPopupIsOpen={loginOptionsPopupIsOpen}
        loginOptionsPopupProps={loginOptionsPopupProps}
      />
      <LoadingLayout loading={false}>
        <ModalClose onClick={closeLoginOptionsPopup} />
        <LoginOptionsForm {...loginOptionsPopupProps} />
        <FourFactorAuthenticationForm {...loginOptionsPopupProps} />
        <LoginOptionsHelpCenter />
      </LoadingLayout>
    </Modal>
  ) : null;
}

// analytics.track causes rerender.
function LogInOptionsPopupEvent({
  loginOptionsPopupIsOpen,
  loginOptionsPopupProps,
}) {
  const { analytics } = useAnalyticsTracker();

  useEffect(() => {
    if (loginOptionsPopupIsOpen) {
      analytics.track("Login Options Modal Load", {
        source: loginOptionsPopupProps.source,
      });
    }
  }, [loginOptionsPopupIsOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}

export default LoginOptionsPopup;
